import React, { useContext } from 'react'
import { motion } from 'framer-motion/dist/framer-motion'

import { DataContext } from '../../../Context/DataContext'
import { UIContext } from '../../../Context/UIContext'

const drawLetter = (color) => {
    return {
        hidden: { pathLength: 0, fill: 'white', fillOpacity: 0, opacity: 0 },
        visible: (i) => {
            const strokeDelay = i * 0.5
            const fillDelay = strokeDelay + 0.75
            return {
                pathLength: 1.1,
                fill: color,
                fillOpacity: 1,
                opacity: 1,
                pathOffset: 0,
                transition: {
                    pathLength: { delay: strokeDelay, duration: 2, ease: "easeInOut" },
                    opacity: { delay: strokeDelay, duration: 0.1 },
                    fillOpacity: { delay: fillDelay, duration: 2, ease: "easeInOut"},
                    fill: { delay: fillDelay, duration: 2, ease: "easeInOut"}
                }
            }
        }
    }
}

const StartButton = () => {
    const { strings } = useContext(DataContext)
    const { setShowIntroLogo } = useContext(UIContext)

    const handleStart = (e) => {
        e.preventDefault()
        setShowIntroLogo(prevShowIntroLogo => !prevShowIntroLogo)
    }

    return (
        <motion.button
            className="mga-start"
            aria-label={strings.begin}
            onClick={handleStart}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 3.75, duration: 1.75 }}
        >
            { strings.begin }
        </motion.button>
    )
}

const Logo = () => {
    const { sitename } = useContext(DataContext)
    return (
        <motion.div
            key="mga-home-logo"
            className="mga-home-section__logo"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0, transition: { duration: 0.5, delay: 0 } }}
            transition={{ duration: 0.1 }}
        >
            <motion.div
                className="mga-logo"
            >
                <motion.svg
                    viewBox="0 0 77 30" 
                    xmlns="http://www.w3.org/2000/svg" 
                    style={{ 
                        fillRule: "evenodd", 
                        clipRule: "evenodd", 
                        strokeLinejoin: "round", 
                        strokeMiterlimit: 2,
                        strokeWidth: 0.2
                    }}
                >
                    <motion.g transform="matrix(1,0,0,1,0.355,0.915)">
                        <motion.path
                            d="M26.26,9.36L26.26,10.49L29.93,6.82C29.81,3.31 26.76,0.01 21.9,0.01C19,0.01 16.89,0.91 15.35,3.34C14.31,1.12 11.52,0.01 9.2,0.01C6.97,-0.13 4.82,0.88 3.51,2.69L3.508,0.55L0,0.55L0,20.37L3.72,20.37L3.72,9.32C3.72,5.99 4.79,3.42 8.62,3.42C10.09,3.33 11.5,4.04 12.31,5.27C12.99,6.51 13.064,7.875 13.13,9.35L13.13,20.37L16.85,20.37L16.85,9.32C16.85,6.06 17.71,3.42 21.57,3.42C25.22,3.42 26.26,6.24 26.26,9.36Z"
                            stroke="#E9540D"
                            fill="white"
                            variants={drawLetter("#E9540D")}
                            initial="hidden"
                            animate="visible"
                            custom={0}
                            style={{
                                fillRule: "nonzero",
                            }}
                        />
                    </motion.g>
                    <motion.g transform="matrix(1,0,0,1,0.355,0.915)">
                        <motion.path
                            d="M49.77,0.56L49.77,2.84C47.98,1 45.51,-0.02 42.94,0.01C40.49,-0.03 38.09,0.79 36.18,2.32C36.18,2.32 35.19,3.22 34.78,3.72L26.26,12.24L26.27,20.37L29.99,20.37L29.99,13.66L38.15,5.36C39.41,4.12 41.1,3.42 42.87,3.43C43.77,3.45 44.65,3.63 45.48,3.97C48.2,4.97 49.94,7.63 49.77,10.52C49.77,10.82 49.74,11.12 49.69,11.42L53.49,7.62L53.49,0.56L49.77,0.56Z"
                            stroke="#EF7D10"
                            fill="white"
                            variants={drawLetter("#EF7D10")}
                            initial="hidden"
                            animate="visible"
                            custom={2}
                            style={{
                                fillRule: "nonzero"
                            }}
                        />
                    </motion.g>
                    <motion.g transform="matrix(1,0,0,1,0.355,0.915)">
                        <motion.path
                            d="M72.55,0.55L72.565,3.34C71.035,1.16 68.42,-0.09 65.76,0.01C61.12,-0.11 56.98,2.92 55.68,7.38L47.32,15.79C46.08,16.9 44.47,17.5 42.81,17.48C39,17.4 35.96,14.28 35.98,10.47C35.98,10.28 35.99,10.1 36.01,9.92L32.68,13.25C34.04,17.74 38.16,20.84 42.85,20.89C47.54,20.89 49.75,17.78 49.75,17.78C49.75,22.32 47.28,24.79 42.77,24.79C40.52,24.88 38.38,23.8 37.12,21.93L32.97,21.93C34.63,25.82 38.51,28.31 42.74,28.19C49.32,28.19 53.47,24.4 53.47,17.71L53.47,14.7L55.43,12.7C56.4,17.59 60.76,21.06 65.75,20.9C71.041,20.9 72.55,17.32 72.55,17.32L72.55,20.4L76.27,20.4L76.27,0.55L72.55,0.55ZM65.77,17.48C65.76,17.48 58.661,18.203 58.95,10.19C59.084,6.49 62.06,3.53 65.76,3.41C69.51,3.36 72.59,6.36 72.64,10.12L72.64,10.5C72.67,14.32 69.59,17.45 65.77,17.48Z"
                            stroke="#505257"
                            fill="transparent"
                            variants={drawLetter("#505257")}
                            initial="hidden"
                            animate="visible"
                            custom={4}
                            style={{
                                fillRule: "nonzero"
                            }}
                        />
                    </motion.g>
                </motion.svg>
                <motion.h1
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 3.25, duration: 1.75 }}
                    dangerouslySetInnerHTML={{ __html: sitename }}
                />
            </motion.div>
            <StartButton />
        </motion.div>
    )
}

export default Logo
